module.exports = __webpack_public_path__ + "img/05.c9c08935.png";